import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { Grid } from '@mui/material';
import { DashboardLayout, GridCard } from '@blumtechgroup/blum-react-core-components';
import { homeInitQuery, HomePageState } from './queries';

const Home = (): React.ReactElement => {
  const navigate = useNavigate();
  const [pageState, setPageState] = useState<HomePageState>({
    users_organisation_admin_aggregate: {
      aggregate: {
        count: 0,
      },
    },
    locations_aggregate: {
      aggregate: {
        count: 0,
      },
    },
    organisation_license_type_assignments_aggregate: {
      aggregate: {
        count: 0,
      },
    },
  });

  const { data: homeInitData } = useQuery(homeInitQuery(), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    if (homeInitData) {
      setPageState(homeInitData);
    }
  }, [homeInitData]);

  const handleAction = (link: string) => {
    navigate(link);
  };

  const actions = [
    {
      title: 'Users',
      counter: pageState.users_organisation_admin_aggregate.aggregate.count,
      createLink: '/org/users/create',
      viewLink: '/org/users',
    },
    {
      title: 'Hospitals',
      counter: pageState.locations_aggregate.aggregate.count,
      createLink: '/org/locations/create',
      viewLink: '/org/locations',
    },
    {
      title: 'License Types',
      counter: pageState.organisation_license_type_assignments_aggregate.aggregate.count,
      createLink: undefined,
      viewLink: '/org/license-types',
    },
    {
      title: 'Dan\'s Fund Questionnaire',
      // counter: 1,
      createLink: undefined,
      viewLink: '/org/dans-fund-questionnaire',
    },
  ];

  return (
    <DashboardLayout title="Organisation Dashboard">
      <Grid container spacing={4}>
        {actions.map((action) => (
          <GridCard
            key={action.title}
            title={action.title}
            counter={action.counter}
            editLabel="Create"
            handleEdit={action.createLink ? () => handleAction(action.createLink) : undefined}
            handleView={() => handleAction(action.viewLink)}
          />
        ))}
      </Grid>
    </DashboardLayout>
  );
};

export default Home;
